import React, { FC, memo, useCallback } from 'react';
import { Select } from 'AurionCR/components/form/select';
import { IDataGridFilter } from 'components/data-grid/model';
import style from './index.module.scss';
import { calcFilterSelectResult } from 'components/data-grid/components/filters/filter-select';
import renderUserDetailsOption, { IUserDetailsItem } from 'components/render-option';
import { useFiltersSheetSettings } from 'components/filters-dialog/context';

/**
 * R-43 (N4b): the SC-06 class. AurionCR's Select hands renderOption to MUI's
 * Autocomplete as is, and MUI calls it (props, option, state) and expects the
 * <li> back. renderUserDetailsOption has the v4 (item) signature, so unadapted
 * it read the <li> props as the item -- every option drew only the "inactive"
 * label -- and the <li> (role, click) was never rendered, so no option could be
 * picked. The same adapter as AppSelect's and FilterSelectWithColoredIcon's.
 */
const renderOption = (
  { key, ...props }: React.HTMLAttributes<HTMLLIElement> & { key?: React.Key },
  option: IUserDetailsItem,
) => (
  <li key={key} {...props}>
    {renderUserDetailsOption(option)}
  </li>
);

const SelectFieldDetails: FC<React.PropsWithChildren<{
  filter: IDataGridFilter;
  value: any;
  onTasks: any;
}>> = ({ filter, value, onTasks }) => {
  const onChange = useCallback((e: any, value: any) => {
    onTasks([
      ['pagination', { page: 1 }],
      // @ts-ignore
      ['filters', { [filter.field]: calcFilterSelectResult(value, filter.options.option.value) }],
      ['getData'],
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // N2 (T5, DC-18 a): "all" as the placeholder in the filters sheet
  const settings = useFiltersSheetSettings(filter.options);
  return (
    <Select
      value={value}
      onChange={onChange}
      renderOption={renderOption}
      className={style.root}
      settings={settings}
      style={filter.options?.style}
    />
  );
};

export default memo(SelectFieldDetails);
